import { render } from "./FeedbackType.vue?vue&type=template&id=4c782aca"
import script from "./FeedbackType.vue?vue&type=script&lang=js"
export * from "./FeedbackType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__